"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blankValues = void 0;
exports.blankValues = {
    string12hr: '--:-- --',
    string24hr: '',
    timeObject: {
        hrs24: null,
        hrs12: null,
        minutes: null,
        mode: null,
    },
};
